import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { Link, useRouteMatch } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import * as Sentry from '@sentry/react';

import SplashWrapper from 'retired/SplashWrapper';
import UserApi from 'entities/user/api';

const RegisterVerify = () => {
  const {
    params: { token },
  } = useRouteMatch<{ token: string }>();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (token) {
      UserApi.unblockOrganizer(token)
        .toPromise()
        .then(() => {
          setLoading(false);
        })
        .catch((e) => {
          setError(true);
          setLoading(false);
          Sentry.captureException(e, { level: 'error' });
        });
    }
  }, []);

  return (
    <SplashWrapper height={550}>
      <Helmet title="Nonprofit Verification" />
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <>
          <h1
            style={{
              fontSize: 25,
              fontWeight: 600,
              marginBottom: 20,
            }}
          >
            Something went wrong!
          </h1>
          <p
            style={{
              marginTop: 20,
            }}
          >
            <strong>Apologies for the inconvenience</strong>
          </p>
          <p>
            We&apos;re here to help! Please try again later or contact{' '}
            <a href="mailto:support@joindeed.com?subject=Failed to verify email!">
              support@joindeed.com
            </a>
          </p>
        </>
      ) : (
        <>
          <h1
            style={{
              fontSize: 25,
              fontWeight: 600,
              marginBottom: 20,
            }}
          >
            Email verification is complete!
          </h1>
          <p>
            You can now log into your account <Link to="/login">here</Link>.
          </p>
        </>
      )}
    </SplashWrapper>
  );
};

export default RegisterVerify;
